import React, { Suspense, lazy } from 'react';
import { LanguageProvider } from './components/LanguageContext';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
// Lazy load below-the-fold components
const TeamOverview = lazy(() => import('./components/TeamOverview').then(module => ({
  default: module.TeamOverview
})));
const KeyPlayers = lazy(() => import('./components/KeyPlayers').then(module => ({
  default: module.KeyPlayers
})));
const MatchCenter = lazy(() => import('./components/MatchCenter').then(module => ({
  default: module.MatchCenter
})));
const StatsData = lazy(() => import('./components/StatsData').then(module => ({
  default: module.StatsData
})));
const HistoricMoments = lazy(() => import('./components/HistoricMoments').then(module => ({
  default: module.HistoricMoments
})));
const FanExperience = lazy(() => import('./components/FanExperience').then(module => ({
  default: module.FanExperience
})));
const TicketsEvents = lazy(() => import('./components/TicketsEvents').then(module => ({
  default: module.TicketsEvents
})));
const Gallery = lazy(() => import('./components/Gallery').then(module => ({
  default: module.Gallery
})));
const Footer = lazy(() => import('./components/Footer').then(module => ({
  default: module.Footer
})));
// Loading fallback
const SectionLoader = () => <div className="w-full h-32 flex items-center justify-center bg-mexico-black" data-id="element-0">
    <div className="w-8 h-8 border-2 border-mexico-red border-t-mexico-green rounded-full animate-spin" data-id="element-1"></div>
  </div>;
export function App() {
  return <LanguageProvider data-id="element-2">
      <div className="min-h-screen bg-mexico-black text-white font-inter selection:bg-mexico-green selection:text-white" data-id="element-3">
        <Navbar data-id="element-4" />
        <main data-id="element-5">
          <HeroSection data-id="element-6" />
          <Suspense fallback={<SectionLoader data-id="element-8" />} data-id="element-7">
            <TeamOverview data-id="element-9" />
            <KeyPlayers data-id="element-10" />
            <MatchCenter data-id="element-11" />
            <StatsData data-id="element-12" />
            <HistoricMoments data-id="element-13" />
            <FanExperience data-id="element-14" />
            <TicketsEvents data-id="element-15" />
            <Gallery data-id="element-16" />
          </Suspense>
        </main>
        <Suspense fallback={<SectionLoader data-id="element-18" />} data-id="element-17">
          <Footer data-id="element-19" />
        </Suspense>
      </div>
    </LanguageProvider>;
}